import get from './get';
import key from './{key}';

export default { get, key };
